export enum EtatDemandeRA {
  EnAttente,
  Lancee,
  Terminee,
  ConnectionPerdueFromBack,
  ConnectionPerdueChangePod,
  Erreur
}